import GSAP from 'gsap'

export default class Preloader {
	constructor(el) {
		this.element 			= el
		
		// this.bg					= this.element.querySelector('.c-Preloader__bg')
		// this.loader				= this.element.querySelector('.c-Preloader__loader')
		// this.loaderNumber 		= this.element.querySelector('.c-Preloader__loader__number')
		// this.mask 				= this.element.querySelector('.c-Preloader__mask')
		// this.logo 				= this.element.querySelector('.c-Preloader__logo')
		// this.targetLoadPercent  = 100

	}

	init() {

		this.createLoader()

	}

	destroyElement() {
		this.element.parentNode.removeChild(this.element)

		if(this.tl) this.tl.kill()
	}

	createLoader() {

		GSAP.set(this.element, {
			visibility: 'visible'
		})

		this.tl = GSAP.timeline()

		this.tl.to(this.element, {
			delay: 2,
			clipPath: 'inset(0% 0% 100% 0%)',
			duration: '0.3',
			onComplete: () => {
				console.log('pageLoaded')
				window.emitter.emit('pageLoaded')
				this.destroyElement()
			}
		})
	}

}
